import { QueryClientProvider } from "react-query";
import { BrowserRouter } from "react-router-dom";

import { CssBaseline, ThemeProvider } from "@mui/material";

import {
  ErrorBoundary,
  UrlFeatureFlagProvider,
  createDefaultTheme,
} from "igfd-ui/src/app-index";

import { createQueryClient } from "igfd-commons/src/query-client-config";

import { DevFriendlyHome } from "./components/dev-page/DevFriendlyHome";
import { RestaurantStaffApp } from "./components/restaurant-staff-app";

function App() {
  const queryClient = createQueryClient();

  const theme = createDefaultTheme({});

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <ErrorBoundary>
        <QueryClientProvider client={queryClient}>
          <BrowserRouter>
            <UrlFeatureFlagProvider>
              <DevFriendlyHome>
                <RestaurantStaffApp />
              </DevFriendlyHome>
            </UrlFeatureFlagProvider>
          </BrowserRouter>
        </QueryClientProvider>
      </ErrorBoundary>
    </ThemeProvider>
  );
}

export default App;
